const RewriteIcon = (props: { color?: string }) => {
    return (
        <svg width="22px" height="17px" viewBox="0 0 22 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopChatHistory1920" transform="translate(-1007, -967)" stroke={props.color ?? "#6C7275"} strokeWidth="2">
                    <g id="Group18" transform="translate(803, 961)">
                        <g id="Group11" transform="translate(205, 0)">
                            <g id="Group9" transform="translate(0, 7)">
                                <polygon id="Stroke1" points="10.5266 13.1622 6.1896 14.3662 7.5156 10.1512 16.5516 1.1162 19.5626 4.1272"></polygon>
                                <line x1="8.241" y1="9.4258" x2="11.252" y2="12.4368" id="Stroke3"></line>
                                <line x1="0" y1="0.5" x2="7.148" y2="0.5" id="Stroke5"></line>
                                <line x1="0" y1="4.5414" x2="4.396" y2="4.5414" id="Stroke7"></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default RewriteIcon;
